<template>
    <div>
        <Panel
            :title="$t('Delivery Points')"
            :add-button="$t('New Delivery Point')"
            :delete-button="selected.length > 0"
            :total-rows="items.length"
            :page="page"
            @delete="handleDelete"
            @input="openForm(-1)"
            @change="setPage"
        >
            <table id="deliverypoints_table" class="cic-table">
                <thead>
                    <tr>
                        <th>{{ $t('Delivery Point Name') }}</th>
                        <th>{{ $t('Outbound Number') }}</th>
                        <th>{{ $t('Max Number of Calls') }}</th>
                        <th>{{ $t('Status') }}</th>
                        <th class="td-checkbox"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="point in points" @click="(evt) => handleOpen(point.pointId, evt)">
                        <td class="primary">
                            {{ point.name }}
                        </td>
                        <td>{{ point.number }}</td>
                        <td>{{ point.maxCalls }}</td>
                        <td>{{ $t(point.disabled ? 'Inactive' : 'Active') }}</td>
                        <td>
                            <cic-checkbox
                                :value="selected.indexOf(point.pointId) !== -1"
                                @click="handleSelected(point.pointId)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </Panel>

        <EditDeliveryPoint
            v-if="item !== null && !$store.showLoadingOverlay"
            :item="item"
            @blur="closePopup"
            @change="updateFieldValue"
            @input="saveItem"
        />

        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import Panel from '@/components/container/Panel';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import TableUtils from '@/mixins/TableUtils';
    import { deleteItems, load, save } from '@/utils/Http';
    import EditDeliveryPoint from './EditDeliveryPoint';

    export default {
        name: 'DeliveryPoints',
        components: {
            CicCheckbox,
            EditDeliveryPoint,
            Panel,
        },
        mixins: [TableUtils],
        data() {
            return {
                item: null,
                items: [],
                page: 1,
                selected: [],
            };
        },
        computed: {
            points() {
                return this.items.slice((this.page - 1) * 20, this.page * 20);
            },
        },
        created() {
            this.loadTable();
        },
        methods: {
            handleDelete() {
                deleteItems('deliverypoints/delete', { pointIds: this.selected }, () => {
                    this.loadTable();
                });
            },

            loadTable() {
                this.item = null;
                this.selected = [];
                load('deliverypoints/get', {}, (response) => {
                    this.items = response.points;
                });
            },

            openForm(pointId) {
                if (pointId > 0) {
                    this.item = { ...this.points.find((point) => point.pointId === pointId) };
                } else {
                    this.item = {
                        pointId: null,
                        name: '',
                        number: '',
                        maxCalls: 0,
                        disabled: false,
                    };
                }
            },

            saveItem() {
                if (this.item.name.trim() === '') {
                    alert(this.$t('Name is a required field'));
                    return;
                }

                if (this.item.number.trim() === '') {
                    alert(this.$t('Outbound Number is a required field'));
                    return;
                }

                const params = {
                    pointId: this.item.pointId,
                    name: this.item.name,
                    number: this.item.number,
                    maxCalls: this.item.maxCalls,
                    disabled: this.item.disabled ? 1 : 0,
                };

                save('deliverypoint/update', params, () => {
                    this.loadTable();
                });
            },
        },
    };
</script>
